import { useMemo } from "react";
import { Card, Descriptions, Typography, type DescriptionsProps } from "antd";
import { MailOutlined } from "@ant-design/icons";
import type { UserProfileType, ErrorResponseType } from "@src/types";
import { CustomResult } from "@repo/ui";
import type { AxiosError } from "axios";

type ProfileProps = {
    data?: UserProfileType;
    loading: boolean;
    error?: AxiosError<ErrorResponseType> | null;
};

export default function ProfileCard({ data, loading, error }: ProfileProps) {
    if (error) {
        return (
            <CustomResult
                type="error"
                axiosError={error}
                title="Ошибка при получений профиля"
                withCard={true}
            />
        );
    }

    const items: DescriptionsProps["items"] = useMemo(
        () => [
            {
                key: "email",
                label: (
                    <span>
                        <MailOutlined /> E-mail
                    </span>
                ),
                children: (
                    <div className="flex items-center gap-2">
                        <Typography.Text copyable={{ text: data?.email }}>
                            {data?.email || "—"}
                        </Typography.Text>
                    </div>
                ),
            },
        ],
        [data?.email],
    );

    return (
        <Card title={data?.name} loading={loading}>
            <Descriptions styles={{ label: { width: 150 } }} items={items} />
        </Card>
    );
}
